import React, { ReactElement } from 'react'
import AnalyticsFilter from './components/analytics-filter/AnalyticsFilter'
import './AnalyticsHeader.less'
import IconArrowLeft from '../../components/common/icon/IconArrowLeft'
import { IconNewTab } from '../../components/common/icon/IconNewTab'
import { ButtonIcon, Link } from 'front-end/src/components'
import { t } from '@lingui/macro'
import { brandColors } from '../../../../shared/basicPalette'
import { AnalyticsFiltersEnum } from './constants'
import { SearchableEntity } from '../../components/common/selectEntitiesForm'
import { CustomEntitiesLoader } from '../../components/common/selectEntitiesForm/FetchEntitiesFromBackendWithCustomQuery'

export interface IAnalyticsHeaderProps {
  goBack?: () => void
  activeFilters?: Array<AnalyticsFiltersEnum>
  children: string | ReactElement
  link?: string
  linkHintText?: string
  showFilterPanel?: boolean
  className?: string
  customDataLoaders?: Partial<
    Record<AnalyticsFiltersEnum, CustomEntitiesLoader>
  >
  customLoadedEntities?: Partial<
    Record<AnalyticsFiltersEnum, SearchableEntity[] | null>
  >
}

export function AnalyticsHeader({
  children,
  showFilterPanel,
  goBack,
  link,
  linkHintText = t`Go to resource`,
  className = '',
  ...props
}: IAnalyticsHeaderProps) {
  return (
    <header className={`${className} AnalyticsHeader`}>
      {goBack && (
        <a onClick={goBack} className="AnalyticsHeader__back">
          <IconArrowLeft />
        </a>
      )}
      <h1 className="AnalyticsHeader__title">{children}</h1>
      {link && (
        <Link isExternal to={link} ml="8px">
          <ButtonIcon
            color={brandColors.grey['700']}
            aria-label={linkHintText}
            hint={linkHintText}
            icon={<IconNewTab w="19px" h="18px" />}
            circular
            hintProps={{
              placement: 'top'
            }}
            _hover={{
              bgColor: 'white'
            }}
          />
        </Link>
      )}
      {showFilterPanel && <AnalyticsFilter {...props} />}
    </header>
  )
}
